"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiPaginationItemOverrides = function (_a) {
    var palette = _a.palette, spacing = _a.spacing, shape = _a.shape;
    return ({
        root: {
            color: palette.text.secondary,
            height: spacing(6),
            minWidth: spacing(6),
            padding: spacing(0, 1),
            margin: spacing(0, 0.5),
            borderRadius: shape.borderRadius,
        },
        page: {
            "&:hover": {
                color: palette.text.primary,
            },
            "&$focusVisible": {
                color: palette.text.primary,
                backgroundColor: palette.action.hover,
                boxShadow: "inset 0px 0px 0px 1px " + palette.common.white,
            },
            "&:active": {
                backgroundColor: palette.background.paper,
            },
            "&$selected": {
                color: palette.text.primary,
                backgroundColor: undefined,
                "&:hover, &$focusVisible": {
                    backgroundColor: undefined,
                    "@media (hover: none)": {
                        backgroundColor: undefined,
                    },
                },
                "&$disabled": {
                    opacity: 1,
                    color: undefined,
                    backgroundColor: undefined,
                },
            },
            "&$disabled": {
                opacity: 0.5,
            },
        },
    });
};
//# sourceMappingURL=MuiPaginationItem.js.map